import loadable from '@loadable/component';

export const SearchEventsPageLoadable = loadable(
  () => import('./SearchEventsPage'),
  { resolveComponent: (module) => module.SearchEventsPage },
);
